import { render, staticRenderFns } from "./PermohonanMain.vue?vue&type=template&id=3d7fa938&scoped=true&"
import script from "./PermohonanMain.vue?vue&type=script&lang=js&"
export * from "./PermohonanMain.vue?vue&type=script&lang=js&"
import style0 from "./PermohonanMain.vue?vue&type=style&index=0&id=3d7fa938&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7fa938",
  null
  
)

export default component.exports